import { call, put, takeLatest, all } from 'redux-saga/effects';
import { handleApiErrors } from 'lib/api-errors';
import {
  ANAL_BASIC_INFO_REQUESTING,
  ANAL_COMPANY_BASIC_REQUESTING,
  ANAL_COMPANY_BIGTRANS_REQUESTING,
  ANAL_COMPANY_EVENTS_REQUESTING,
  ANAL_COMPANY_HOLDER_REQUESTING,
  ANAL_COMPANY_INTRODUCTION_REQUESTING,
  ANAL_COMPANY_LEADER_REQUESTING,
  ANAL_COMPANY_RELATED_REQUESTING,
  ANAL_COMPANY_SAME_IND_REQUESTING,
  ANAL_DEL_FILTER_REQUESTING,
  ANAL_FILTER_ACT_REQUESTING,
  ANAL_FILTER_RANGE_REQUESTING,
  ANAL_FS_RATIO_REQUESTING,
  ANAL_INDEX_REAL_REQUESTING,
  ANAL_LICH_SU_GIA_REQUESTING,
  ANAL_NN_INDAY_REQUESTING,
  ANAL_PB_DONG_TIEN_REQUESTING,
  ANAL_RANK_FS_RATIO_REQUESTING,
  ANAL_SEC_LIST_ALL_REQUESTING,
  ANAL_SEC_OVERVIEW_REQUESTING,
  ANAL_STOCK_MATCH_PRICE_REQUESTING,
  ANAL_STOCK_MB_ACTIVE_REQUESTING,
  ANAL_STOCK_REAL_REQUESTING,
  ANAL_USER_FILTER_REQUESTING,
  ANAL_USER_SIGNAL_REQUESTING,
} from './constants';

import {
  analBasicInfoError,
  analBasicInfoSuccess,
  analComBasicError,
  analComBasicSuccess,
  analComBigTransError,
  analComBigTransSuccess,
  analComEventsError,
  analComEventsSuccess,
  analComHolderError,
  analComHolderSuccess,
  analComIntroductionError,
  analComIntroductionSuccess,
  analComLeaderError,
  analComLeaderSuccess,
  analComRelatedError,
  analComRelatedSuccess,
  analComSameIndustryError,
  analComSameIndustrySuccess,
  analDelFilterError,
  analDelFilterSuccess,
  analFilterActionError,
  analFilterActionSuccess,
  analFilterRangeError,
  analFilterRangeSuccess,
  analFSRatioError,
  analFSRatioSuccess,
  analIndexRealError,
  analIndexRealSuccess,
  analLichSuGiaError,
  analLichSuGiaSuccess,
  analNNIndayError,
  analNNIndaySuccess,
  analPBDongTienError,
  analPBDongTienSuccess,
  analRankFSRatioError,
  analRankFSRatioSuccess,
  analSecListAllError,
  analSecListAllSuccess,
  analSecOverviewError,
  analSecOverviewSuccess,
  analStockMatchPriceError,
  analStockMatchPriceSuccess,
  analStockMBActiveError,
  analStockMBActiveSuccess,
  analStockRealError,
  analStockRealSuccess,
  analUserFilterError,
  analUserFilterSuccess,
  analUserSignalError,
  analUserSignalSuccess,
} from './actions';
import { mapIndexList } from 'utils/config';

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      throw error;
    });
}

function summaryApi(data) {
  const request = fetch(appUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function analSecListAllRequestApi(data) {
  const request = fetch(appUrl + 'pbapi/api/secListAll', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getLichSuGia(data) {
  const request = fetch(appUrl + 'pbapi/api/secTradingHistory', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getBasicInfo(data) {
  const request = fetch(appUrl + 'pbapi/api/securityBasicInfo', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getFSRatio(data) {
  const request = fetch(appUrl + 'pbapi/api/secFSRatios', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getRankFSRatio(data) {
  const request = fetch(appUrl + 'pbapi/api/secRankingFSRatios', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getSecOverview(data) {
  const request = fetch(appUrl + 'pbapi/api/secOverview', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getComIntroduction(data) {
  const request = fetch(appUrl + 'pbapi/api/companies/introduction', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getComBasic(data) {
  const request = fetch(appUrl + 'pbapi/api/companies/basic', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getComSameInd(data) {
  const request = fetch(appUrl + 'pbapi/api/companies/sameIndustry', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getComLeader(data) {
  const request = fetch(appUrl + 'pbapi/api/companies/leaders', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getComHolder(data) {
  const request = fetch(appUrl + 'pbapi/api/companies/shareholders', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getComEvents(data) {
  const request = fetch(appUrl + 'pbapi/api/news/sec_news?startDate=' + data.startDate + '&reqLanguage=' + data.lang.toUpperCase() + '&secCode=' + data.secCode);
  return handleRequest(request);
}

function getComBigTrans(data) {
  const request = fetch(appUrl + 'pbapi/api/secBigTrans', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getComRelated(data) {
  const request = fetch(appUrl + 'pbapi/api/companies/relatedCompanies?' + data);
  return handleRequest(request);
}

function getUserFilter(data) {
  const request = fetch(appUrl + 'pbapi/api/getFilters', 
  {
    method: 'GET',
    headers: {
      'X-USERNAME': data,
    },
  });
  return handleRequest(request);
}

function getUserSignal(data) {
  // const request = fetch(appUrl + 'pbapi/api/signals/' + data,
  const request = fetch(appUrl + 'pbapi/api/usersignals/' + data,
  {
    method: 'GET',
    headers: {
      'X-USERNAME': data,
    },
  });
  return handleRequest(request);
}

function getFilterAct(data) {
  const _user = data['user'];
  delete data['user'];

  const request = fetch(appUrl + 'pbapi/api/filter', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'X-USERNAME': _user,
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function delFilterApi(data) {
  const _user = data['user'];
  delete data['user'];

  const request = fetch(appUrl + 'pbapi/api/deleteFilter', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'X-USERNAME': _user,
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function getIndexRealtime(data) {
  const request = fetch(
    appUrl + 'pbapi/api/stockBoard/index/' + mapIndexList[data]
  );
  return handleRequest(request);
}

function getStockRealtime(data) {
  const request = fetch(appUrl + 'pbapi/api/stockBoard/stock/' + data);
  return handleRequest(request);
}

function getStockMatchPrice(data) {
  const request = fetch(appUrl + 'pbapi/api/stockBoard/stock/getDetailsActively/' + data);
  return handleRequest(request);
}

function getStockMBActive(data) {
  const request = fetch(appUrl + 'pbapi/api/stockBoard/stock/getDetailsActivelyByPrice/' + data);
  return handleRequest(request);
}

function getFilterRange() {
  const request = fetch(appUrl + 'pbapi/api/getFilterRange');
  return handleRequest(request);
}

function getPBDongTien(data) {
  let _param = ''
  switch (data) {
    case 'VNINDEX':
      _param = 'HOSE';
      break;
    case 'HNX':
    case 'HNXINDEX':
      _param = 'HNC';
      break;
    case 'UPCOMINDEX':
    case 'UPCOM':
      _param = 'UPCOM';
      break;
  
    default:
      _param = data;
      break;
  }

  const request = fetch(appUrl + 'pbapi/api/stockBoard/index/calculateCashFlowAllocation/' + _param);
  return handleRequest(request);
}

function getNNInday(data) {
  const request = fetch(appUrl + 'pbapi/api/stockBoard/index/getFGDetails/' + mapIndexList[data]);
  return handleRequest(request);
}

function* analIndexRealRequestFlow({ params }) {
  try {
    const resData = yield call(getIndexRealtime, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analIndexRealSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analIndexRealError(error));
  }
}

function* analStockInfoRequestFlow({ params }) {
  try {
    const resData = yield call(getBasicInfo, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analBasicInfoSuccess(resData.data[0]));
  } catch (error) {
    // log(error)
    yield put(analBasicInfoError(error));
  }
}

function* analStockRealRequestFlow({ params }) {
  try {
    const resData = yield call(getStockRealtime, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analStockRealSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analStockRealError(error));
  }
}

function* analStockMatchPriceRequestFlow({ params }) {
  try {
    const resData = yield call(getStockMatchPrice, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analStockMatchPriceSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analStockMatchPriceError(error));
  }
}

function* analStockMBActiveRequestFlow({ params }) {
  try {
    const resData = yield call(getStockMBActive, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analStockMBActiveSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analStockMBActiveError(error));
  }
}

function* analPBDongTienRequestFlow({ params }) {
  try {
    const resData = yield call(getPBDongTien, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analPBDongTienSuccess(resData.data[0]));
  } catch (error) {
    // log(error)
    yield put(analPBDongTienError(error));
  }
}

function* analNNIndayRequestFlow({ params }) {
  try {
    const resData = yield call(getNNInday, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analNNIndaySuccess(resData.data[0]));
  } catch (error) {
    // log(error)
    yield put(analNNIndayError(error));
  }
}

function* analLichSuGiaRequestFlow({ params }) {
  try {
    const resData = yield call(getLichSuGia, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analLichSuGiaSuccess(JSON.parse(resData.data)));
  } catch (error) {
    // log(error)
    yield put(analLichSuGiaError(error));
  }
}

function* analFSRatioRequestFlow({ params }) {
  try {
    const resData = yield call(getFSRatio, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analFSRatioSuccess(JSON.parse(resData.data)));
  } catch (error) {
    // log(error)
    yield put(analFSRatioError(error));
  }
}

function* analRankFSRatioRequestFlow({ params }) {
  try {
    const resData = yield call(getRankFSRatio, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analRankFSRatioSuccess(JSON.parse(resData.data)));
  } catch (error) {
    // log(error)
    yield put(analRankFSRatioError(error));
  }
}

function* analSecOverviewRequestFlow({ params }) {
  try {
    const resData = yield call(getSecOverview, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analSecOverviewSuccess(JSON.parse(resData.data)));
  } catch (error) {
    // log(error)
    yield put(analSecOverviewError(error));
  }
}

function* analComIntroductionRequestFlow({ params }) {
  try {
    const resData = yield call(getComIntroduction, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComIntroductionSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analComIntroductionError(error));
  }
}

function* analComBasicRequestFlow({ params }) {
  try {
    const resData = yield call(getComBasic, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComBasicSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analComBasicError(error));
  }
}

function* analComSameIndRequestFlow({ params }) {
  try {
    const resData = yield call(getComSameInd, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComSameIndustrySuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analComSameIndustryError(error));
  }
}

function* analComLeaderRequestFlow({ params }) {
  try {
    const resData = yield call(getComLeader, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComLeaderSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analComLeaderError(error));
  }
}

function* analComHolderRequestFlow({ params }) {
  try {
    const resData = yield call(getComHolder, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComHolderSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analComHolderError(error));
  }
}

function* analComEventsRequestFlow({ params }) {
  try {
    const resData = yield call(getComEvents, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComEventsSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analComEventsError(error));
  }
}

function* analComBigTransRequestFlow({ params }) {
  try {
    const resData = yield call(getComBigTrans, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComBigTransSuccess(JSON.parse(resData.data)));
  } catch (error) {
    // log(error)
    yield put(analComBigTransError(error));
  }
}

function* analComRelatedRequestFlow({ params }) {
  try {
    const resData = yield call(getComRelated, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analComRelatedSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analComRelatedError(error));
  }
}

function* analFilerRangeRequestFlow() {
  try {
    const resData = yield call(getFilterRange);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analFilterRangeSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analFilterRangeError(error));
  }
}

function* analFilerActRequestFlow({ params }) {
  try {
    const resData = yield call(getFilterAct, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message || resData?.dict?.errorMessage || 'Error',
      });
      throw Error(resData.message || resData?.dict?.errorMessage || 'Error');
    }

    yield put(analFilterActionSuccess(resData.data));
  } catch (error) {
    // log(error)
    yield put(analFilterActionError(error));
  }
}

function* analUserFilerRequestFlow({ params }) {
  try {
    const resData = yield call(getUserFilter, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analUserFilterSuccess(resData.data));
  } catch (error) {
    yield put(analUserFilterError(error));
  }
}

function* analDelFilerRequestFlow({ params }) {
  try {
    const resData = yield call(delFilterApi, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analDelFilterSuccess(Math.random()));
  } catch (error) {
    yield put(analDelFilterError(error));
  }
}

function* analUserSignalRequestFlow({ params }) {
  try {
    const resData = yield call(getUserSignal, params);
    if (resData.status != 200) {
      yield put({
        type: 'REQUEST_PRIVATE_FALSE',
        msg: resData.message,
      });
      throw Error(resData.message);
    }

    yield put(analUserSignalSuccess(resData.data));
  } catch (error) {
    yield put(analUserSignalError(error));
  }
}

function* analSecListAllRequestFlow({ params }) {
  try {
    const resData = yield call(analSecListAllRequestApi, params);
    yield put(analSecListAllSuccess(JSON.parse(resData.data)?.dict));
  } catch (error) {
    yield put(analSecListAllError(error));
  }
}

function* tradingWatcher() {
  yield all([
    takeLatest(ANAL_SEC_LIST_ALL_REQUESTING, analSecListAllRequestFlow),
    takeLatest(ANAL_INDEX_REAL_REQUESTING, analIndexRealRequestFlow),
    takeLatest(ANAL_NN_INDAY_REQUESTING, analNNIndayRequestFlow),
    takeLatest(ANAL_PB_DONG_TIEN_REQUESTING, analPBDongTienRequestFlow),
    takeLatest(ANAL_LICH_SU_GIA_REQUESTING, analLichSuGiaRequestFlow),
    takeLatest(ANAL_FS_RATIO_REQUESTING, analFSRatioRequestFlow),
    takeLatest(ANAL_RANK_FS_RATIO_REQUESTING, analRankFSRatioRequestFlow),

    takeLatest(ANAL_BASIC_INFO_REQUESTING, analStockInfoRequestFlow),
    takeLatest(ANAL_STOCK_REAL_REQUESTING, analStockRealRequestFlow),
    takeLatest(ANAL_STOCK_MATCH_PRICE_REQUESTING, analStockMatchPriceRequestFlow),
    takeLatest(ANAL_STOCK_MB_ACTIVE_REQUESTING, analStockMBActiveRequestFlow),

    takeLatest(ANAL_SEC_OVERVIEW_REQUESTING, analSecOverviewRequestFlow),
    takeLatest(ANAL_COMPANY_INTRODUCTION_REQUESTING, analComIntroductionRequestFlow),
    takeLatest(ANAL_COMPANY_BASIC_REQUESTING, analComBasicRequestFlow),
    takeLatest(ANAL_COMPANY_SAME_IND_REQUESTING, analComSameIndRequestFlow),
    takeLatest(ANAL_COMPANY_LEADER_REQUESTING, analComLeaderRequestFlow),
    takeLatest(ANAL_COMPANY_HOLDER_REQUESTING, analComHolderRequestFlow),
    takeLatest(ANAL_COMPANY_EVENTS_REQUESTING, analComEventsRequestFlow),
    takeLatest(ANAL_COMPANY_BIGTRANS_REQUESTING, analComBigTransRequestFlow),
    takeLatest(ANAL_COMPANY_RELATED_REQUESTING, analComRelatedRequestFlow),

    /** filter */
    takeLatest(ANAL_FILTER_RANGE_REQUESTING, analFilerRangeRequestFlow),
    takeLatest(ANAL_FILTER_ACT_REQUESTING, analFilerActRequestFlow),
    takeLatest(ANAL_USER_FILTER_REQUESTING, analUserFilerRequestFlow),
    takeLatest(ANAL_DEL_FILTER_REQUESTING, analDelFilerRequestFlow),

    /** signal */
    takeLatest(ANAL_USER_SIGNAL_REQUESTING, analUserSignalRequestFlow),
  ]);
}

export default tradingWatcher;
